import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import type { ColumnDef } from '@tanstack/react-table';
import SPADataTable from '../shared/SPADataTable';
import SPASectionHeading from '../shared/SPASectionHeading';
import { FeatureUsage } from './types';
import { formatTokens } from './usagePalette';

interface FeatureRow {
  feature: string;
  requests: number;
  tokens: number;
}

const columnHelper = createColumnHelper<FeatureRow>();

const columns = [
  columnHelper.accessor('feature', { header: 'Feature' }),
  columnHelper.accessor('requests', {
    cell: info => info.getValue().toLocaleString(),
    header: 'Requests',
    meta: { align: 'right' },
  }),
  columnHelper.accessor('tokens', {
    cell: info => formatTokens(info.getValue()),
    header: 'Tokens',
    meta: { align: 'right' },
  }),
] as ColumnDef<FeatureRow, unknown>[];

const FeatureTotals = ({ byFeature }: { byFeature?: FeatureUsage }) => {
  const rows = Object.entries(byFeature ?? {})
    .map(([feature, usage]) => ({ feature, ...usage }))
    .sort((a, b) => b.tokens - a.tokens);

  return (
    <section>
      <SPASectionHeading title="Features" />
      <SPADataTable
        columns={columns}
        data={rows}
        defaultSort={[]}
        emptyMessage="No AI calls recorded in this window."
        isLoading={!byFeature}
        loadingRows={3}
      />
    </section>
  );
};

export default FeatureTotals;
